import { ByteUtil, GuidUtil } from '../../utils/index';
import { Constant } from '../../utils/constant';
import { CallEventMsg } from '../../protobuf/callEvent';
import { CallEventOptMsg } from '../../protobuf/callEventOpt';
export default {
    sendCallEvent(clientStater, fromGuid, toGuid, houseGuid, totalGuids, version) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            let loginMsgByte = this.buildCallBody(_guid, fromGuid, toGuid, houseGuid, totalGuids, version);
            clientStater.send(loginMsgByte);

      console.log('sendCallEvent', loginMsgByte);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response.msg });
                }
                else {
                    reject({ code: response.code, msg: response.msg });
                }
            });
        });
    },
    callCallEventOpt(clientStater, callGuid, fromOrClient, allOrReject, toGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            let loginMsgByte = this.buildCallEventOptBody(_guid, callGuid, fromOrClient ? CallEventOptMsg.OptFrom.FROM : CallEventOptMsg.OptFrom.CLIENT, allOrReject ? CallEventOptMsg.CallOpt.ALLOW : CallEventOptMsg.CallOpt.REJECT, toGuid);
            clientStater.send(loginMsgByte);
      console.log('callCallEventOpt', loginMsgByte);
            clientStater.onevent(_guid, (response) => {
                if (response.code == 200) {
                    reslove({ code: response.code, msg: response.msg });
                }
                else {
                    reject({ code: response.code, msg: response.msg });
                }
            });
        });
    },
    buildCallBody(guid, fromGuid, toGuid, houseGuid, totalGuids, version) {
        var callEventMsg = {
            version: version,
            fromGuid: fromGuid,
            toGuid: toGuid,
            guid: guid,
            houseGuid: houseGuid,
            totalGuids: totalGuids
        };
        //编码
        let utf8 = CallEventMsg.encode(callEventMsg).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.CALLEVENT]),
            utf8
        ]);
        return sendByte;
    },
    buildCallEventOptBody(guid, callGuid, optFrom, opt, toGuid) {
        var callEventMsg = {
            guid: guid,
            version: 1,
            refGuid: callGuid,
            optFrom: optFrom,
            opt: opt,
            toGuid: toGuid
        };
        //编码
        let utf8 = CallEventOptMsg.encode(callEventMsg).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.CALLEVENTOPT]),
            utf8
        ]);
        return sendByte;
    }
};
//# sourceMappingURL=callEventBiz.js.map
